<template>
     <div>
        <p v-if="!dataLoaded">Loading...</p>

        <BaseList
            v-if="dataLoaded"
            search-placeholder="Search by locker combination name..."
            :filtered-count="filteredCombinations.length"
            :total-count="combinations.length"
            :current-page="currentPage"
            :items-per-page-prop="itemsPerPage"
            @search="handleSearch"
            @page-change="changePage"
            @items-per-page-change="handleItemsPerPageChange"
        >
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Standard Config?</th>
                        <th>Outdoor?</th>
                        <th>Total Lockers</th>
                        <th>Total Price</th>
                        <th>Overall Width</th>
                        <th>Overall Height</th>
                        <th>Overall Depth</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="combo in paginatedCombinations" :key="combo.id">
                        <td><router-link :to="'/lockercombinations/'+combo.id">{{combo.name}}</router-link></td>
                        <td>{{combo.standardConfig ? 'Standard' : 'Project Specific'}}</td>
                        <td>{{combo.isOutdoor ? '✓' : ''}}</td>
                        <td>{{combo.totalLockers}}</td>
                        <td>${{combo.totalPrice.toFixed(2) || "N/A"}}</td>
                        <td>{{combo.totalWidth.toFixed(2) || "N/A"}}</td>
                        <td>{{combo.totalHeight.toFixed(2) || "N/A"}}</td>
                        <td>{{combo.totalDepth.toFixed(2) || "N/A"}}</td>
                    </tr>
                </tbody>
            </table>
        </BaseList>
    </div>
</template>

<script>
    import {CallApi} from '../Utilities.js'
    import BaseList from './BaseList.vue'

    export default {
        name: 'CombinationList',
        components: {
            BaseList
        },
        data: function() {
            return {
                dataLoaded: false,
                combinations: [],
                filteredCombinations: [],
                currentPage: 1,
                itemsPerPage: 50
            }
        },
        computed: {
            paginatedCombinations: function() {
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.filteredCombinations.slice(start, end);
            }
        },
        methods: {
            fuzzyMatch: function(searchText, targetText) {
                const search = searchText.toLowerCase().trim();
                const target = targetText.toLowerCase();

                if (!search) return true;

                const searchTerms = search.split(/\s+/).map(term => {
                    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    return `(?:^|[^a-z0-9])${escaped}`;
                });

                const pattern = searchTerms.map(term => `(?=.*${term})`).join('');
                const regex = new RegExp(pattern);

                return regex.test(target);
            },
            handleSearch: function(searchText) {
                if (!searchText) {
                    this.filteredCombinations = this.combinations;
                } else {
                    this.filteredCombinations = this.combinations.filter(combo => {
                        return this.fuzzyMatch(searchText, combo.name || '');
                    });
                }
                this.currentPage = 1;
            },
            changePage: function(newPage) {
                this.currentPage = newPage;
            },
            handleItemsPerPageChange: function(newValue) {
                this.itemsPerPage = newValue;
                this.currentPage = 1;
            },
            fetchData: async function() {
                this.combinations = (await CallApi('GET', '/combinations')).combinations
                this.filteredCombinations = this.combinations;
                this.dataLoaded = true
            }
        },
        mounted: function () {
            this.fetchData()
        }
    }
</script>
